// extracted by mini-css-extract-plugin
export default {"zoomModal":"w1-z","image":"x1-z","button":"y1-z","isOverlayShown":"z1-z"};